import { CSSProperties } from 'react';

export enum MediaBreakpoint {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

export const viewportWidth = (viewport: MediaBreakpoint) => {
  switch (viewport) {
    case MediaBreakpoint.MD:
      return '990px';
    case MediaBreakpoint.SM:
      return '390px';
    case MediaBreakpoint.LG:
    default:
      return '100%';
  }
};

export interface Media {
  hidden: MediaBreakpoint[];
  css: Record<MediaBreakpoint, CSSProperties>;
}
